import {
    HomeIcon,
    ServerIcon,
    ShoppingCartIcon,
    ShoppingBagIcon,
    UserIcon,
    BarChart3Icon,
    BellIcon,
    BookOpenIcon,
    GiftIcon,
    Ticket
} from 'lucide-react'

export const menuGroups = [
    {
        title: '基础导航',
        gradient: 'from-cyan-400 via-blue-500 to-indigo-600',
        items: [
            { title: '仪表盘', icon: HomeIcon, path: '/dashboard', badge: null },
            { title: '消息通知', icon: BellIcon, path: '/notifications', badge: 3 },
            { title: '文档中心', icon: BookOpenIcon, path: '/docs', badge: null },
        ],
    },
    {
        title: '服务中心',
        gradient: 'from-violet-400 via-purple-500 to-fuchsia-600',
        items: [
            { title: '订阅套餐', icon: ShoppingCartIcon, path: '/plans', badge: null },
            { title: '节点列表', icon: ServerIcon, path: '/servers', badge: null },
        ],
    },
    {
        title: '财务管理',
        gradient: 'from-emerald-400 via-teal-500 to-cyan-600',
        items: [
            { title: '我的订单', icon: ShoppingBagIcon, path: '/orders', badge: null },
            { title: '推广返利', icon: GiftIcon, path: '/invite', badge: null },
        ],
    },
    {
        title: '账号设置',
        gradient: 'from-amber-400 via-orange-500 to-red-600',
        items: [
            { title: '个人信息', icon: UserIcon, path: '/profile', badge: null },
            { title: '工单支持', icon: Ticket, path: '/tickets', badge: 1 },
            { title: '流量统计', icon: BarChart3Icon, path: '/traffic', badge: null },
        ],
    },
]
